<template>
   <v-system-bar
      v-if="authStore.isImpersonating"
      color="warning"
      height="36"
      class="px-4"
   >
      <v-icon size="small" class="mr-2">fas fa-user-secret</v-icon>
      <span body-medium>
         Viewing as <strong>{{ targetName }}</strong> (impersonation by an administrator)
      </span>
      <v-spacer></v-spacer>
      <v-btn size="x-small" variant="outlined" @click="onStop()">Stop impersonating</v-btn>
   </v-system-bar>
</template>

<script lang="ts">
import {useAuthStore} from '@src/store/auth_store';
import {mapStores} from 'pinia';
import {defineComponent} from 'vue';

/**
 * Banner shown across the app while an admin is impersonating another user, with a
 * control that ends the impersonation and restores the admin session.
 */
export default defineComponent({
   computed: {
      ...mapStores(useAuthStore),

      /** The impersonated user is the signed-in user while impersonation is on. */
      targetName(): string {
         return this.authStore.user?.name ?? 'this user';
      },
   },

   methods: {
      onStop(): void {
         this.authStore.stopImpersonation();
      },
   },
});
</script>

<style lang="scss" scoped></style>
